import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from '@sendgrid/ui-components';
import Styles from './duetodaycontainer.module.scss';
import { calculateEstimatedProratedPrice, calculateEasePrice } from '../utils/displayHelpers';
import TotalRow from './TotalRow';
import withPackages from '../containers/withPackages';
import withAddOns from '../containers/withAddOns';
import { ADDONS } from '../constants';

const DueTodayContainer = (props) => {
  const isPro = props.packages.activePackage.plan_type === 'pro';
  const pkgPrice = calculateEstimatedProratedPrice(props.packages.activePackage.base_price);
  const addonsPrice = (!props.packages.activeIsFree ?
    calculateEstimatedProratedPrice(calculateEasePrice(
      props.addOns[ADDONS.EASE],
      props.packages.activePackage.name,
    ))
    : 0)
    + calculateEstimatedProratedPrice(isPro ?
      props.addOns[ADDONS.DEDICATED_IP] * ADDONS.IP_COST : 0);
  // not needed for now, but probably will be.
  // const isPro = props.packages.activePackage.plan_type === 'pro';
  // const addOnsPrice = isPro ?
  //   calculateEstimatedProratedPrice(props.addOns[ADDONS.DEDICATED_IP] * ADDONS.IP_COST) :
  //   0;
  // const proratedPrice =
  //   calculateEstimatedProratedPrice(props.addOns[ADDONS.DEDICATED_IP] * ADDONS.IP_COST);
  return (
    <section className={Styles.paytoday} >
      <h3>{props.title}&nbsp;
        <Tooltip content={props.tooltipcontent} title="" direction="up">
          <Icon type="info-circle" />
        </Tooltip>
      </h3>
      <table>
        <tbody>
          {/* { props.addOns[ADDONS.DEDICATED_IP] && addOnsPrice > 0 ?
            <tr>
              <th className={Styles.servicerow}>
                {formatIpString(props.addOns[ADDONS.DEDICATED_IP])} (Prorated)
              </th>
              <td className={Styles.price}>
                {dollarize(addOnsPrice)}
              </td>
            </tr> :
            null */}

          <TotalRow isDueToday total={pkgPrice + addonsPrice} label={`Prorated plan${addonsPrice > 0 ? ' and add-ons' : ''}${props.packages.activeIsFree ? '' : '*'}`} />


        </tbody>
      </table>
    </section>
  );
};

DueTodayContainer.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipcontent: PropTypes.string.isRequired,
  packages: PropTypes.shape({
    activePackage: PropTypes.object.isRequired,
    activeIsFree: PropTypes.bool.isRequired,
  }).isRequired,
  addOns: PropTypes.shape({
    [ADDONS.EASE]: PropTypes.number.isRequired,
    [ADDONS.DEDICATED_IP]: PropTypes.number.isRequired,
  }).isRequired,
};

export default withPackages(withAddOns(DueTodayContainer));



// WEBPACK FOOTER //
// ./src/components/DueTodayContainer.jsx